(() => {
  if (window.roxariPreviewReady) return;
  window.roxariPreviewReady = true;
  function preview(event) {
    const item = event.target.closest('[data-preview-src]');
    if (!item) return;
    const menu = item.closest('[data-roxari-menu]');
    const link = menu?.querySelector('[data-preview-link]');
    const img = link?.querySelector('img');
    if (!img) return;
    const src = item.dataset.previewSrc;
    menu.dataset.requestedPreview = src;
    const next = new Image();
    next.onload = () => {
      if (menu.dataset.requestedPreview !== src || !item.isConnected) return;
      img.removeAttribute('srcset');
      img.src = src;
      img.alt = item.dataset.previewTitle;
      link.href = item.href;
      menu.querySelector('[data-preview-caption]').textContent = item.dataset.previewTitle;
    };
    next.src = src;
  }
  document.addEventListener('mouseover', preview);
  document.addEventListener('focusin', preview);
})();

(() => {
  if (!document.body.classList.contains('template-index')) return;
  const root = document.documentElement;
  const headers = [...document.querySelectorAll('.shopify-section-group-header-group')];
  const update = () => {
    const height = headers.reduce((sum, el) => sum + el.getBoundingClientRect().height, 0);
    root.style.setProperty('--roxari-header-height', height + 'px');
  };
  const observer = new ResizeObserver(update);
  headers.forEach(el => observer.observe(el));
  window.addEventListener('resize', update, { passive: true });
  update();
})();

(() => {
  const init = () => {
    document.querySelectorAll('.roxari-desktop-details').forEach(menu => {
      if (menu.dataset.roxariBound) return;
      menu.dataset.roxariBound = 'true';
      const summary = menu.querySelector('summary');
      let timer;
      const close = () => { menu.open = false; summary.setAttribute('aria-expanded', 'false'); };
      const open = () => {
        document.querySelectorAll('.roxari-desktop-details[open]').forEach(other => { if (other !== menu) { other.open = false; other.querySelector('summary').setAttribute('aria-expanded', 'false'); } });
        menu.open = true; summary.setAttribute('aria-expanded', 'true');
      };
      let hoverOpened = false;
      summary.addEventListener('click', event => {
        event.preventDefault();
        if (menu.open && hoverOpened) { hoverOpened = false; return; }
        menu.open ? close() : open();
      });
      menu.addEventListener('pointerenter', event => {
        clearTimeout(timer);
        if (event.pointerType === 'mouse' && menu.dataset.roxariHover === 'true') { open(); hoverOpened = true; }
      });
      menu.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') { hoverOpened = false; timer = setTimeout(close, 180); }
      });
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); summary.focus(); } });
      menu.addEventListener('focusout', event => { if (!menu.contains(event.relatedTarget)) close(); });
      document.addEventListener('click', event => { if (!menu.contains(event.target)) close(); });
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  document.addEventListener('click', event => {
    const back = event.target.closest('.roxari-mobile-back');
    if (!back) return;
    const menu = back.closest('.roxari-mobile-menu');
    if (!menu) return;
    menu.open = false;
    menu.querySelector(':scope > summary')?.focus();
  });
})();
